import * as React from "react";
import { User } from "../../../types/User";
import { Book } from "../../../types/Book";
import { API_URL } from "../../../utils";
import Avatar from "@material-ui/core/Avatar/Avatar";
import "./UserList.css";
import PopupUserList from "./PopupUserList/PopupUserList";
import Link from "@material-ui/core/Link/Link";
import { useSelector } from "react-redux";
import { getUserProfile } from "../../../store/user/selectors";

interface Props {
	book: Book;
	initialLabel?: string;
}

interface LabelUser {
	startUser: User;
	otherUsers?: User[];
}

const UserList: React.FC<Props> = ({ book, initialLabel }) => {
	const [users, setUsers] = React.useState<User[]>([]);
	const [open, setOpen] = React.useState(false);
	const currentUser = useSelector(getUserProfile);

	const request = async () => {
		const data = await fetch(`${API_URL}/books/users?id=${book.woo_id}`, {
			credentials: "include",
		});

		return await data.json();
	};

	React.useEffect(() => {
		request().then((data) => {
			const users: User[] = data;

			if (users.length > 0 && currentUser.id > 0) {
				setUsers(users.filter(user => user.id !== currentUser.id))
			}
			else {
				setUsers(data);
			}
		});
	}, [book]);

	const usersLabel: LabelUser = React.useMemo(() => {
		if (users.length === 0) {
			return null;
		}

		const label: LabelUser = {
			startUser: users[0],
			otherUsers: users.length > 1 ? users.slice(1) : [],
		};

		return label;
	}, [users]);

	return usersLabel ? (
		<div className="userList">
			<Avatar src={usersLabel.startUser.imageURL} className="userList_avatar" />

			<span>
				{initialLabel ? initialLabel : 'В библиотеке у '}
				<a href={`/profile/#/${usersLabel.startUser.id}`}>
					{usersLabel.startUser.name}
				</a>
				{usersLabel.otherUsers.length > 0 && (
					<span>
						&nbsp;и{" "}
						<span onClick={() => setOpen(true)} className="userList__more">
							еще {usersLabel.otherUsers.length}
						</span>
					</span>
				)}
			</span>

			{open && <PopupUserList onClose={() => setOpen(false)} users={users} />}
		</div>
	) : (
		<></>
	);
};

export default UserList;
